<template>
  <!--FAQ Page -->

  <div class="page-margin">
    <!--breadcrumb start-->
    <div class="breadcrumb-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6 d-align-center">
            <h2 class="title"><span>FAQ</span></h2>
          </div>
          <div class="col-md-6 col-sm-6">
            <nav class="theme-breadcrumb" aria-label="breadcrumb">
              <ol class="breadcrumb bg-transparent mb-0">
                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                <li class="breadcrumb-item active"><a href="#">/FAQ</a></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!--breadcrumb end -->

    <!-- faq -->
    <section class="faq blog-page">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="accordion" id="accordionExample">
              <div
                class="card mb-3"
                v-for="(card, index) in cards"
                :key="index"
              >
                <div class="card-header" id="headingTwo">
                  <h5 class="mb-0" @click="changeCardState(card.id)">
                    <button
                      class="btn btn-link collapsed"
                      type="button"
                      data-toggle="collapse"
                      :class="cardActive(card.id) ? '' : 'collapsed'"
                      data-target="#collapseTwo"
                      aria-controls="collapseTwo"
                      :aria-expanded="cardActive(card.id) ? 'true' : 'false'"
                    >
                      {{ card.title
                      }}<i
                        class="fa pull-right"
                        :class="
                          cardActive(card.id) ? 'fa-angle-up' : 'fa-angle-down'
                        "
                      ></i>
                    </button>
                  </h5>
                </div>
                <div
                  :class="cardActive(card.id) ? 'show' : 'collapse'"
                  id="collapseTwo"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    {{ card.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="animation-circle absolute"><i></i><i></i><i></i></div>
      <div class="animation-circle-inverse"><i></i><i></i><i></i></div>
    </section>
    <!-- faq end -->

    <!--Footer Section start-->
    <footer class="cpoy-right-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="social-footer">
              <ul>
                <li>
                  <a href="#"
                    ><i class="fa fa-facebook" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a href="#"
                    ><i class="fa fa-google-plus" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a href="#"
                    ><i class="fa fa-twitter" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a href="#"
                    ><i class="fa fa-instagram" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <p class="copyright">
              2018-19 حقوق الطبع والنشر بواسطة غابةالموضوع مدعوم من حزام البكسل
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!--Footer Section End-->
  </div>
  <!--end Faq Page-->
</template>
<script>
export default {
  name: "Review",
  beforeCreate: function () {
    document.body.className = "inner-page";
  },
  methods: {
    cardActive(id) {
      return this.activeCards[id - 1];
    },
    changeCardState(id) {
      this.activeCards[id - 1] = !this.activeCards[id - 1];
      for (let i = 0; i <= this.activeCards.length - 1; i++) {
        if (i != id - 1) this.activeCards[i] = false;
      }
    },
  },
  data() {
    return {
      activeCards: [true, false, false, false],

      cards: [
        {
          id: 1,
          title: "01 We're ready to start now",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporoincididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
        },
        {
          id: 2,
          title: "02 Sedeiusmod tm inccsetetur ?",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
        },
        {
          id: 3,
          title: "03 Sedeiusmod inc aliquatraiy?",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
        },
        {
          id: 4,
          title: "04 Tempor inc aliquatraiy?",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
        },
      ],
    };
  },
};
</script>
